<template>
  <div class="project-detail">
    <div class="title van-multi-ellipsis--l2">{{ info.event_name }}</div>
    <div>
      <span>{{ info.user_name }}</span>
      <span>{{ info.event_date | formatDate('yyyy/MM/dd') }}</span>
      <span>{{ info.start_time | formatDate('hh:mm') }}-{{ info.end_time | formatDate('hh:mm') }}</span>
    </div>
    <div class="main">
      <div @click="handleNext" class="upload-icon">
        <van-icon name="plus" />
      </div>
      <div @click="previewImg(index)" class="work-container" v-for="(item, index) in info.event_homeworks" :key="index">
        <img :src="$isCdn(item.homeworkUrl)" alt="" />
      </div>
    </div>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {getLessonHomeworks} from '@/api'
export default {
  data() {
    return {
      code: this.$route.params.code,
      info: {}
    }
  },
  created() {
    this.init()
  },
  methods: {
    previewImg(index) {
      const images = this.info.event_homeworks.map(item => this.$isCdn(item.homeworkUrl))
      this.$ImagePreview({
        images,
        startPosition: index
      })
    },
    init() {
      getLessonHomeworks({code: this.code}).then(res => {
        if (res.code === 0) {
          this.info = res.data
        }
      })
    },
    handleNext() {
      this.$router.push(`/projectUpload/${this.code}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.project-detail {
  padding: 12px 16px;
}
.title {
  color: #303133;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}
span {
  color: #909399;
  font-size: 15px;
  font-weight: 500;
}

span:nth-child(2) {
  margin: 0 10px;
}
.main {
  // display: flex;
  // align-items: center;
  // flex-wrap: wrap;
  // justify-content: space-between;
  margin-top: 30px;
  .upload-icon {
    display: inline-block;
    width: 109px;
    height: 109px;
    border: 1px dashed #e7e9ef;
    border-radius: 6px;
    position: relative;
    margin-bottom: 4px;
    margin-right: 4px;
    i {
      font-size: 30px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #c0c4cc;
    }
  }
  .work-container {
    width: 109px;
    height: 109px;
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 4px;
    margin-right: 4px;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
